import { useEffect } from 'react'
import { useUserRoles } from 'src/Hooks/user'
import { useTypedSelector } from 'src/State/RootReducer'
import { getOwnerNameForBrowserTab } from '../utils'
import { isFlowTheme } from 'src/Libs/utils'
import { getTitleWithoutOwnerName, getTitleWithOwnerName } from 'src/Elements/Framework/utils/framework'

const DEFAULT_BROWSER_TAB_TITLE = isFlowTheme ? 'Hager Flow' : 'E3/DC Portal'

/**
 * Set the browser tab title based on the installation data
 */
const useSetBrowserTabTitle = (): void => {
  const { isInstaller, isPartner, isServiceUser, isAdmin } = useUserRoles()
  const installation = useTypedSelector(state => state.storage.installation)

  useEffect(() => {
    if (installation?.id && browserTabTitle) {
      document.title = browserTabTitle
      return
    }

    /* reset to default title */
    document.title = DEFAULT_BROWSER_TAB_TITLE
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installation?.id])

  if (!installation) return undefined

  const { ownerFirstName, ownerLastName, emsMasterDeviceId } = installation

  const ownerName = getOwnerNameForBrowserTab(ownerFirstName, ownerLastName)
  const storageId = emsMasterDeviceId
  const titleWithOwnerName = getTitleWithOwnerName(ownerName, storageId)
  const titleWithoutOwnerName = getTitleWithoutOwnerName(isFlowTheme, storageId)

  const showOwnerName = isInstaller || isPartner || isServiceUser || isAdmin
  const browserTabTitle = showOwnerName && titleWithOwnerName ? titleWithOwnerName : titleWithoutOwnerName
}

export default useSetBrowserTabTitle
